import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wishlistCount: 0,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    setWishlistCount: (state, action) => {
      state.wishlistCount = action.payload;
    },
    incrementWishlistCount: (state) => {
      state.wishlistCount += 1;
    },
    decrementWishlistCount: (state) => {
      if (state.wishlistCount > 0) {
        state.wishlistCount -= 1;
      }
    },
  },
});

export const { setWishlistCount, incrementWishlistCount, decrementWishlistCount } = wishlistSlice.actions;
export default wishlistSlice.reducer;